import React, { useState, useEffect } from "react";
import axios from "axios";
import { Select, Form } from "antd";
import { API_KEY_OPENAI } from "../../../../config";
export default function SelectModel({ onSelect, value }) {
  const [models, setModels] = useState([]);
  useEffect(() => {
    axios
      .get("https://api.openai.com/v1/models", {
        headers: {
          Authorization: `Bearer ${API_KEY_OPENAI}`,
        },
      })
      .then((res) => {
        return res.data.data;
      })
      .then((res) => {
        let data = res
          .map((e) => {
            return {
              value: e.id,
              label: e.id.replace(/-/g, " "),
            };
          })
          .filter((e) => {
            const noneArray = [
              "codex",
              "image",
              "gpt-4o-mini-tts-2025-12-15",
              "gpt-realtime-mini-2025-12-15",
              "audio",
              "realtime",
              "search-preview",
              "transcribe",
              "tts",
            ];
            var isShow = true;
            noneArray.forEach((s) => {
              if (e.value.indexOf(s) >= 0) {
                isShow = false;
              }
            });
            return isShow;
          });
        data = data.filter((e) => e.value.indexOf("gpt") >= 0);
        setModels(data);
      });
  }, []);
  return (
    <Form.Item name="model" label="Model">
      <Select
        defaultValue={value}
        value={value}
        style={{
          width: 200,
        }}
        options={models}
        onChange={(v) => {
          onSelect(v);
        }}
      />
    </Form.Item>
  );
}
